<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title']
            }),
            new fields.Switch({
              label: 'Rozwijalne',
              modelPath: [this, 'form', 'is_expandable']
            }),
            {
              component: 'h3',
              innerText: 'Osoby'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              blankObject: { images: [] },
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['name']),
                fields: [
                  new fields.Input({
                    label: 'Nazwa',
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'name']
                  }),
                  new fields.Input({
                    label: 'Tytuł w prawej kolumnie',
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'right_title']
                  }),
                  new fields.Input({
                    label: 'Opis',
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'description']
                  }),
                  new fields.Input({
                    label: 'Opis po rozwinięciu',
                    type: 'textarea',
                    modelPath: [
                      this,
                      'form',
                      'items',
                      i,
                      'expandable_description'
                    ]
                  }),
                  new fields.Switch({
                    label: 'Czarno-białe zdjęcia',
                    modelPath: [this, 'form', 'items', i, 'is_black_and_white']
                  }),
                  {
                    component: 'h3',
                    innerText: 'Zdjęcia'
                  },
                  new fields.Formset({
                    modelPath: [this, 'form', 'items', i, 'images'],
                    items: this.form.items[i].images.map(
                      (image, imageIndex) => {
                        return {
                          headerLabel: get(image, ['title']),
                          fields: [
                            new fields.Image({
                              label: 'Zdjęcie',
                              modelPath: [
                                this,
                                'form',
                                'items',
                                i,
                                'images',
                                imageIndex
                              ]
                            })
                          ]
                        }
                      }
                    )
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
